import { render, staticRenderFns } from "./GamesDescribe.vue?vue&type=template&id=1a7a122c&scoped=true"
import script from "./GamesDescribe.vue?vue&type=script&lang=js"
export * from "./GamesDescribe.vue?vue&type=script&lang=js"
import style0 from "./GamesDescribe.vue?vue&type=style&index=0&id=1a7a122c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a122c",
  null
  
)

export default component.exports